import axios from 'axios';
// Public catalog reads never refresh credentials; the backend ignores authentication.
const backend = (process.env.REACT_APP_BACKEND_URL ||
    (process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:8000')).replace(/\/+$/, '');
export const publicCatalogClient = axios.create({baseURL: `${backend}/api/`, withCredentials: false});
export interface PublicPrice {
    plan_nombre: string;
    precio_inicial: string | number;
    precio_posterior: string | number | null;
    duracion_inicial: number | null;
    unidad: string;
    horas: number | null;
    dias: number | null;
}
export interface PublicService {
    slug: string;
    nombre: string;
    descripcion: string;
    imagen: string | null;
    categoria_nombre: string;
    categoria_slug: string;
    requiere_espacio: boolean;
    planes: PublicPrice[];
    espacios: {nombre: string; descripcion: string; imagen: string | null; capacidad: number; sucursal: string}[];
    sucursales: {nombre: string; direccion: string}[];
}
export const fetchPublicServices = async (category: string, legacy = false): Promise<PublicService[]> => {
    const response = await publicCatalogClient.get<PublicService[]>('catalogo-servicios/', {
        params: legacy ? {categoria: category} : {categoria_slug: category},
    });
    return response.data;
};
export const fetchPublicService = async (slug: string, legacy = false): Promise<PublicService> => {
    const endpoint = legacy ? 'servicios-public' : 'catalogo-servicios';
    return (await publicCatalogClient.get<PublicService>(`${endpoint}/${encodeURIComponent(slug)}/`)).data;
};
